export default "__VITE_ASSET__C6xK2RD6__"